/**
 * - Checks if has number digits
 * @param {any} event
 * @param {Function} updateFunction
 */
export function validatePhoneNumber(event, updateFunction) {
  const reg = /^[0-9\b]+$/;
  const preval = event.currentTarget.value;
  if (event.currentTarget.value === '' || reg.test(event.currentTarget.value)) {
    updateFunction(event.currentTarget.value);
  } else {
    event.currentTarget.value = preval.substring(0, preval.length - 1);
  }
}

/**
 * @param {Number} number
 * @returns decimal price
 */
export function getPrice(number) {
  const format = number ? Number(number).toLocaleString('it-IT', { minimumFractionDigits: 2 }) : '';

  return format;
}
